import { mapValues } from 'lodash';

const prefix = typeof window !== 'undefined' && window.location.pathname.startsWith('/iam') ? '/iam' : '';

const paths = {
  login: '',
  changePassword: 'change-password',
  completeSignUp: 'complete-sign-up',
  createAccount: 'create-account',
  emailUpdate: 'email-update',
  forgotPassword: 'forgot-password',
  passwordExpired: 'password-expired',
  passwordReset: 'password-reset',
};

export default mapValues(paths, path => `${prefix}/${path}`);
